import * as React from 'react';

import {BaseRow} from '../../row/base-row/base-row';
import type {BaseRowStatusBadge, ToolbarProps} from '../../row/base-row/base-row';
import type {TertiaryActionProps} from '../../row/base-row/tertiary-action';
import type {SelectMenuOption} from '../../select-menu/select-menu';

import {ContactCardContents} from './contact-card-contents';

type Props = {
    name: string | null | undefined;
    description?: string | null | undefined;
    role?: string | null | undefined;
    phoneNumber: string | null | undefined;
    phoneExtension?: string | null | undefined;
    email: string | null | undefined;
    phoneContent?: React.ReactNode;
    emailContent?: React.ReactNode;
    lastContactedTime?: string | null | undefined;
    icon?: React.ReactNode;
    tertiaryProps?: TertiaryActionProps;
    actionMenuOptions?: Array<SelectMenuOption>;
    contactUrl?: string | null | undefined;
    statusBadges?: BaseRowStatusBadge[];
    toolbarProps?: ToolbarProps;
    successFlashKey?: string;
};

export function ContactCard(props: Props) {
    return (
        <BaseRow
            title={props.name || `Unnamed person`}
            type='contacts'
            customIcon={props.icon}
            tertiaryProps={props.tertiaryProps}
            actionMenuOptions={props.actionMenuOptions}
            url={props.contactUrl || undefined}
            statusBadges={props.statusBadges}
            toolbarProps={props.toolbarProps}
            successFlashKey={props.successFlashKey}
        >
            <ContactCardContents
                description={props.description}
                role={props.role}
                phoneNumber={props.phoneNumber}
                phoneExtension={props.phoneExtension}
                email={props.email}
                phoneContent={props.phoneContent}
                emailContent={props.emailContent}
                lastContactedTime={props.lastContactedTime}
            />
        </BaseRow>
    );
}
